import { getToken, net } from '../../admincore'
import { API_URL } from '../../utils/constants'

const { get } = net

// eslint-disable-next-line
export const getTrips = (companyId, params) => get(`${API_URL}/${companyId}/orders`, params, getToken())
export const downloadTripsApi = (companyId, params) => get(`${API_URL}/${companyId}/orders/download`, params, getToken())
